module.exports = __webpack_public_path__ + "static/media/search parent regist.f17573aa.svg";